import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { navigate } from '../utils/navigation';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/prenup/SystemUser/Login');
    }
  }, [loading, isAuthenticated]);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="container">
          <div className="row justify-content-center align-items-center min-vh-100">
            <div className="col-auto text-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="sr-only">جاري التحميل...</span>
              </div>
              <h5>جاري تحميل التطبيق...</h5>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null; // Will redirect in useEffect
  }

  return <>{children}</>;
};

export default ProtectedRoute;